/** Forge Suite shared types — same shape as Binder / BookForge / ImageForge. */

export interface SuiteUser {
  id: string;
  email: string;
  full_name: string | null;
  is_active?: boolean;
  picture_url?: string | null;
}

export interface WalletSnapshot {
  balanceUsd: number;
  currency: string;
  subscriptionActive?: boolean;
  subscriptionLabel?: string | null;
  stripeConfigured?: boolean;
  packs?: { amountUsd: number; label: string }[];
}

export interface SuiteSettings {
  forgeApiUrl: string;
  activeInstanceId: string | null;
  /** Optional local GPT-SoVITS api_v2 base (default http://127.0.0.1:9880) */
  localApiUrl?: string;
}

export const DEFAULT_SUITE_SETTINGS: SuiteSettings = {
  forgeApiUrl: "http://127.0.0.1:8787",
  activeInstanceId: null,
  localApiUrl: "http://127.0.0.1:9880",
};
